"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const IpiTooltip = () => (react_1.default.createElement(CustomToolTip_1.default, { type: '?', inverse: true, place: 'right', info: 'A Writer IPI (Interested Party Information) –is assigned by PROs to songwriters and publishers to uniquely identify them as legal international rights holders.' }));
exports.default = IpiTooltip;
